import React from 'react';
import { useTranslation } from 'react-i18next';
import WaitlistSection, { WAITLIST_ANCHOR } from './WaitlistSection';

// What /configure renders while PRELAUNCH_MODE is on: the same waitlist form,
// same strings, instead of the signup wizard. /configure has no /fr prefix, so
// the language comes from i18next — which LandingV6 syncs to the URL locale and
// persists — with FR as the fallback (Loi 101).
const PrelaunchWaitlistPage: React.FC = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language?.startsWith('en') ? 'en' : 'fr';
  return (
    <div className="min-h-screen bg-[#FAF6EF] flex items-center">
      <div className="w-full">
        <WaitlistSection locale={locale} anchorId={WAITLIST_ANCHOR} />
      </div>
    </div>
  );
};

export default PrelaunchWaitlistPage;
